import React from 'react';
import {
  Table,
  TableRow,
  TableBody,
  TableCell,
  TableContainer,
  Paper,
} from '@mui/material';
import PropTypes from 'prop-types';
import CellValue from './cell-value.component';
import CELL_DATA_TYPES from '../../config/cell-types.config';
import ViewListData from './view-list-data.component';

const ViewData = ({ columns, row, fetchData }) => (
  <TableContainer component={Paper}>
    <Table>
      <TableBody>
        {columns.map((c) => (
          <>
            <TableRow />
            <TableRow key={`col-${c.id}`}>
              <TableCell
                width="25%"
                variant="head"
                sx={{ border: 0, verticalAlign: 'top' }}
              >
                {c.label}
              </TableCell>
              <TableCell
                width="75%"
                variant="body"
                sx={{ border: 0, verticalAlign: 'top' }}
              >
                {c.type === CELL_DATA_TYPES.TABLE_LIST ? (
                  <ViewListData
                    fetchData={fetchData}
                    columns={c.tableListColumns}
                  />
                ) : (
                  <CellValue type={c.type} value={row[c.dataKey]} />
                )}
              </TableCell>
            </TableRow>
          </>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

ViewData.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  row: PropTypes.shape().isRequired,
  fetchData: PropTypes.func,
};
ViewData.defaultProps = {
  fetchData: () => {},
};

export default ViewData;
